import { useHistory } from "react-router";
import { generateQualityMetricsValidationColumns } from "../../columns/QualityMetricsValidationColumns";
import { StateValues } from "../../types";
import { useEffect, useState } from "react";
import StandardList from "../common/StandardList";
import { useGetValidationResultsQuery } from "../DataValidation/api";
import { useGetDQMValidationResultsQuery } from "./api";
import { getAccessRequestsAsync } from "../../reducers/AccessPackages";
import { useAppDispatch } from "../../hooks/ReduxHooks";
import { getErrorMessage } from "../AccessPackages/utils";
import MenuButton from "./MenuButton";

export function QMValidationView() {
    
    const [stateValues, setStateValues] = useState<StateValues>("INIT");
    const [errorMsg, setErrorMsg] = useState<string>();
    const { data, isLoading, error } = useGetDQMValidationResultsQuery();
    const [filteredData, setFilteredData] = useState(data);
    const [filterLabel, setFilterLabel] = useState("Filter By");

    const history = useHistory();
    const dispatch = useAppDispatch();

    useEffect(() => {
        document.title = "Summary of Data Quality Metrics Validation Results - SIP Portal";
        dispatch(getAccessRequestsAsync());
    }, []);

    useEffect(() => {
        // need to manual set the state since this is a non standard implementation
        if (isLoading) {
            setStateValues("LOADING_ALL");
        }

        if (data && !isLoading) {
            setFilteredData(data);
            setStateValues("LOADED_ALL");
        }
    }, [data, isLoading]);

    useEffect(() => {
        if (error) {
            const strError = getErrorMessage(error);
            setErrorMsg(strError);
        } else {
            setErrorMsg(undefined);
        }
    }, [error]);

    return (
        <StandardList
            entities={filteredData}
            title={"Data Quality Metrics Validation Results"}
            columns={generateQualityMetricsValidationColumns(history)}
            error={errorMsg}
            entityState={stateValues}
            extraHeaderItems={
                <MenuButton
                    filterLabel={filterLabel}
                    setFilterLabel={setFilterLabel}
                    setFilteredData={setFilteredData}
                    data={data}
                />
            }
        />
    );
}